import axios from '../axios';

const path = '/api/route';
export default {
  route() {
    return axios.get(path);
  },
};
